module.exports = __webpack_public_path__ + "static/media/12UNCTAD2.eeea15d4.jpg";